export function createSucursal() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    EsDefault: false,
    EsActivo: true
  };
}
